import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-profile-image',
  template: `<div [ngStyle]="{
                  'background-color': backgroundColor,
                  'width': '35px',
                  'height': '35px',
                  'border-radius': '50%',
                  'color': 'white',
                  'display': 'flex',
                  'justify-content': 'center',
                  'align-items': 'center',
                  'font-size': '20px'
                }">{{ initials }}</div>`,
  styles: []
})
export class ProfileImageComponent implements OnChanges {
  @Input() fullName: string = '';
  initials: string = '';
  backgroundColor: string = '#000';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullName']) {
      this.initials = this.getInitials(this.fullName);
      this.backgroundColor = this.getRandomColor();
    }
  }

  private getInitials(name: string): string {
    const names = name.split(' ');
    const initials = names.reduce((acc, curr) => acc += curr[0] || '', '');
    return initials.toUpperCase();
  }

  private getRandomColor(): string {
    const colors = ['#8A9A5B', '#DC143C', '#FF8C00', '#8E4585', '#008080', '#CFB53B', '#00BFFF', '#2F4F4F'];
    return colors[Math.floor(Math.random() * colors.length)];
  }
}
